<template>
  <v-dialog v-model="activeLocal" fullscreen transition="dialog-bottom-transition">
    <v-card>
      <v-card-title style="height: 15%">
        Selecione a Senha
        <v-btn color="red" icon="mdi-close" style="position: absolute; top: 0; right: 0;" variant="text" @click="senhaSelecionada = null; activeLocal = false; diaSelecionado = null" />
        <v-select
          :items="getDiasArray"
          label="Selecione o dia que deseja correr"
          v-model="diaSelecionado"
          :item-props="diaItemProps"
          variant="outlined"
          density="compact"
        />
      </v-card-title>
      <v-card-text style="height: 70%; overflow-y: scroll">
        <v-chip-group active-class="primary--text" column color="primary" v-model="senhaSelecionada">
          <div v-for="(dia, index) in diasSenhas" :key="index">
            <span v-if="diaSelecionado === index + 1" style="margin-left: 15px">Mapa de Senhas do {{ index + 1 }}º dia</span>
            <div style="display: flex; flex-wrap: wrap; flex-direction: row; justify-content: space-evenly" v-if="diaSelecionado === index + 1">
              <v-chip
                v-for="n in (dia as any).quantidade"
                :key="index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n"
                label
                :value="index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n"
                style="font-size: 12px"
                :text="`Senha ${String(index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n).padStart(3, '0')}`"
                variant="elevated"
                color="primary"
                :disabled="senhasReservadas.includes(index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n) || senhasPagas.includes(index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n) || senhasNoCarrinho.includes(index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n)"
                :style="chipColorSenha(index > 0 ? n + somarQuantidadesIndicesAnteriores(index) : n)"
              />
            </div>
          </div>
        </v-chip-group>
      </v-card-text>
      <v-card-actions style="height: 15%">
        <p style="font-size: 10px">
          Legenda:<br>
          <v-icon icon="mdi-circle" color="yellow" /> Reservadas<br>
          <v-icon icon="mdi-circle" :color="store.getIsDark ? 'grey' : 'black'" /> Disponíveis<br>
          <v-icon icon="mdi-circle" color="red" /> Compradas<br>
          <v-icon icon="mdi-circle" color="primary" /> Sua escolha<br>
          <v-icon icon="mdi-circle" color="green" /> No Carrinho de Compras
        </p>
        <v-spacer />
        <v-btn color="primary" :variant="!senhaSelecionada ? 'text' : 'elevated'" text="Continuar" :disabled="!senhaSelecionada" @click="selecionarSenha" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useAppStore } from '@/stores/app'

  export default defineComponent({
    name: 'GeradorMapaSenhas',
    data: () => ({
      senhaSelecionada: null,
      activeLocal: false,
      diaSelecionado: 1,
      store: useAppStore(),
    }),
    props: {
      active: {
        type: Boolean,
        required: true
      },
      quantidadeSenhas: {
        type: Number,
        required: true
      },
      dataInicio: {
        type: String,
        required: true
      },
      dataFim: {
        type: String,
        required: true
      },
      senhas: {
        type: Array,
        required: true
      },
      diasSenhas: {
        type: Array,
        required: true
      },
      isAdmin: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      quantidadeDias () {
        const dataInicio = new Date(this.dataInicio);
        const dataFim = new Date(this.dataFim);
        const diferenca = dataFim.getTime() - dataInicio.getTime();
        return Math.ceil(diferenca / (1000 * 60 * 60 * 24)) + 1;
      },
      senhasReservadas () {
        const senhasReservadas: number[] = [];

        this.senhas.forEach((senha: any) => {
          if (senha.statusPagamento === 0) {
            senhasReservadas.push(senha.senha.numero);
          }
        });

        return senhasReservadas;
      },
      senhasPagas () {
        const senhasPagas: number[] = [];

        this.senhas.forEach((senha: any) => {
          if (senha.statusPagamento === 1) {
            senhasPagas.push(senha.senha.numero);
          }
        });

        return senhasPagas;
      },
      senhasNoCarrinho () {
        return this.store.getSenhasNoCarrinho;
      },
      chipColorSenha () {
        return (senha: number) => {
          if (this.senhasReservadas.includes(senha)) {
            return 'background-color: yellow; color: black; opacity: 1 !important;';
          } else if (this.senhasPagas.includes(senha)) {
            return 'background-color: red; color: white; opacity: 1 !important;';
          } else if (this.senhasNoCarrinho.includes(senha)) {
            return 'background-color: green; color: white; opacity: 1 !important;';
          } else {
            return '';
          }
        };
      },
      getDiasArray() {
        return Array.from({ length: this.quantidadeDias }, (_, index) => index + 1);
      }
    },
    methods: {
      selecionarSenha () {
        this.$emit('senhaSelecionada', {
          senha: this.senhaSelecionada,
          dia: this.diaSelecionado
        });
        this.activeLocal = false;
        this.senhaSelecionada = null;
      },
      diaItemProps (item: number) {
        if (!item) return;
        const baseDate = this.dataInicio.split('T')[0].split('-').reverse();
        return {
          title: `${item}º dia — ${Number(baseDate[0]) + (item - 1)}/${baseDate[1]}/${baseDate[2]}`,
          value: item
        }
      },
      somarQuantidadesIndicesAnteriores (index: number) {
        let soma = 0;
        for (let i = 0; i < index; i++) {
          soma += this.diasSenhas[i].quantidade;
        }
        return soma;
      },
      verificarSenhasDisponiveis(index: number): boolean {
        if (index < 0 || index >= this.diasSenhas.length) {
          return false; // Retorna falso se o índice estiver fora do intervalo
        }
        const diaSelecionado = this.diasSenhas[index];
        for (let i = 1; i <= diaSelecionado.quantidade; i++) {
          const senha = index > 0 ? i + this.somarQuantidadesIndicesAnteriores(index) : i;
          if (!this.senhasReservadas.includes(senha) && !this.senhasPagas.includes(senha)) {
            return true; // Existe pelo menos uma senha disponível
          }
        }

        return false; // Todas as senhas desse dia estão reservadas ou pagas
      }
    },
    emits: ['senhaSelecionada', 'update:active'],
    watch: {
      active () {
        this.activeLocal = this.active;
      },
      activeLocal () {
        this.$emit('update:active', this.activeLocal);
      }
    },
    mounted () {
      for (let i = this.diaSelecionado; i <= this.quantidadeDias; i++) {
        this.diaSelecionado = i; // Atualiza para o próximo dia disponívels
        if (this.verificarSenhasDisponiveis(i - 1)) {
          break;
        }
      }
    }
  })
</script>

<style scoped>

</style>
